module.exports = __webpack_public_path__ + "static/img/2.2e860c99.png";